import { DriverUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { driverStatusLabels } from '../enumLabels';

type DriverUpdatedDetailProps = {
  event: DriverUpdatedEvent;
};

export const DriverUpdatedDetail = ({ event }: DriverUpdatedDetailProps) => {
  const previous = event.previousDriver;
  const current = event.updatedDriver;

  if (!previous || !current) {
    return (
      <Col className="@DriverUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'firstName',
      label: 'First Name',
      previous: previous.firstName,
      current: current.firstName,
    },
    {
      field: 'lastName',
      label: 'Last Name',
      previous: previous.lastName,
      current: current.lastName,
    },
    {
      field: 'status',
      label: 'Status',
      previous: driverStatusLabels[previous.status],
      current: driverStatusLabels[current.status],
    },
    {
      field: 'email',
      label: 'Email',
      previous: previous.email,
      current: current.email,
    },
    {
      field: 'phoneNumber',
      label: 'Phone',
      previous: previous.phoneNumber,
      current: current.phoneNumber,
    },
    {
      field: 'licenseNumber',
      label: 'License Number',
      previous: previous.licenseNumber,
      current: current.licenseNumber,
    },
    {
      field: 'userId',
      label: 'User ID',
      previous: previous.userId?.value ?? '',
      current: current.userId?.value ?? '',
    },
  ];

  return (
    <Col className="@DriverUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Driver</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay
            label="Name"
            value={`${current.firstName} ${current.lastName}`}
          />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
